<div class="kb-container">

  <!-- Quick Guides Section -->
  <ng-container *ngIf="quickGuideResources.length > 0">
    <div class="kb-list">
      <ng-container *ngFor="let item of quickGuideResources; trackBy: trackByResourceTitle">
        <wf-knowledge-base-item
          (click)="goToItem(item)"
          [title]="item.title"
          [description]="item.description"
          [thumbnail]="item.icon">
        </wf-knowledge-base-item>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="otherResources.length > 0">
    <!-- Main items (all except last two) -->
    <div class="kb-list" *ngIf="otherResources.length > 2">
      <ng-container *ngFor="let item of otherResources.slice(0, -2); trackBy: trackByResourceTitle">
        <wf-knowledge-base-item
          (click)="goToItem(item)"
          [title]="item.title"
          [description]="item.description"
          [thumbnail]="item.icon">
        </wf-knowledge-base-item>
      </ng-container>
    </div>
    
    <!-- Last two items -->
    <div class="kb-list">
      <ng-container *ngFor="let item of otherResources.slice(-2); trackBy: trackByResourceTitle">
        <wf-knowledge-base-item
          (click)="goToItem(item)"
          [title]="item.title"
          [description]="item.description"
          [thumbnail]="item.icon">
        </wf-knowledge-base-item>
      </ng-container>
    </div>
  </ng-container>

  <!-- no resources are available -->
  <div *ngIf="quickGuideResources.length === 0 && otherResources.length === 0" class="kb-no-resources">
    <p>No resources found.</p>
  </div>
</div>